'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './feedback.routes';


export class FeedbackComponent {
  /*@ngInject*/
  constructor(feedbackService, $scope, $http, baseConfigService) {
    this.$scope = $scope;
    this.$http = $http;

    
    // Services 
    this.feedbackService = feedbackService;
    this.baseConfigService = baseConfigService;
  }
  $onInit(){
    
    this.getAllFeedback();
  }

  /**
   * Gets a list of all application feedback and populated HandsonTable
   * Service: feedbackService (app/components/services/feedback)
   * @param N/A
   */
  getAllFeedback(){
    var adminBaseURL = this.baseConfigService.getAdminBaseURL();
    function generateUUID() {
      // Get current time in milliseconds
      var d = new Date().getTime();
   
      // Define the UUID template with placeholder characters
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
   
      // Replace the placeholders with random hexadecimal digits
      uuid = uuid.replace(/[xy]/g, function(c) {
          // Generate a random number between 0 and 15
          var r = (d + Math.random()*16)%16 | 0;
   
          // Update value of d for the next placeholder
          d = Math.floor(d/16);
   
          // Convert the number to a hexadecimal digit and return it
          return (c=="x" ? r : (r&0x3|0x8)).toString(16);
      });
   
      return uuid;

    }
    
    this.feedbackService.getAllFeedback()
    .then(feedback => {
      this.$scope.rowCollection = feedback.data;
      
    const container = document.querySelector('#example5');
    const data = feedback.data;

    var thisIsValid = this.$scope.thisIsValid;
   
    
    this.$scope.hot = new Handsontable(container, {
      data,
      colHeaders: true,
      allowInsertRow: true,
      manualColumnResize: true,
      height: 'auto',
      stretchH: "all",
      width: "100%",
      autoWrapRow: true,
      rowHeaders: true,
      filters: true,
      contextMenu: true,
      dropdownMenu: [
        "filter_by_condition",
        "filter_by_value",
        "filter_action_bar",
      ],
      hiddenColumns: { // enable hiding columns
        indicators: true,
      },
      manualColumnMove: true, // enable moving columns
      manualColumnFreeze: true, // enable freezing columns
      manualColumnResize: true, // enable resizing columns
      multiColumnSorting: {
        indicator: true,
      },
      colHeaders: [
        "ID",
        "Type",
        "Comment",
        "Email",
        "Status",
        "Source",
        "Date",
        "Asana",
        "Github"],
      columns: [
        { data: 'recid' },
        { data: 'type' },
        { data: 'comment' },
        { data: 'email' },
        { data: 'status',
            type: "dropdown",
              source: [
                "submitted",
                "reviewed"
              ],
              strict: true 
            },
        { data: 'source' },
        { data: 'date' },
        { data: 'asana',
            type: "checkbox",
            className: "htCenter"
        },
        { data: 'github',
            type: "checkbox",
            className: "htCenter"
        },
      ],
      minSpareRows: 1,
      licenseKey: 'non-commercial-and-evaluation',
      afterValidate(isValid, value, row, prop, source) {
        thisIsValid = isValid;
      },
    });

    var hot = this.$scope.hot;
    var http = this.$http;
    var feedbackService = this.feedbackService;

    hot.addHook("afterChange", function(changes, source) {
      var updateData = [];
     changes.forEach(([row]) => {
        var handsonUpdate = hot.getDataAtRow(row);
        updateData.push({
          recid: handsonUpdate[0],
          type: handsonUpdate[1],
          comment: handsonUpdate[2],
          email: handsonUpdate[3],
          status: handsonUpdate[4],
          source: handsonUpdate[5],
          date: handsonUpdate[6],
          asana: handsonUpdate[7],
          github: handsonUpdate[8]
        });
      });
      if(typeof thisIsValid === "undefined") {
        http
          .post(`${adminBaseURL}/feedback/update`, updateData)
          .then((responseReport) => {
          })
          .catch((err) => {
            console.log(err);
          });
      } else if(!thisIsValid) {
        console.log("its not valid");
      } else {
        // update data in database
        http
          .post(`${adminBaseURL}/feedback/update`, updateData)
          .then((responseReport) => {
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });

    hot.addHook("afterCreateRow", function(index, amount, source) {
      data[index].recid = generateUUID();
     });

    hot.addHook("beforeRemoveRow", function(index, amount, physicalRows, source) {
      feedbackService.deleteFeedback(data[index].recid)
      .then(response => {
        
      })
      .catch(err => {
        console.log(err);
      })
    });

    // hot.addHook("beforeRemoveRow", function(index, amount, physicalRows, source) {
    //   console.log(data[index]);
    //  console.log(amount)
    //  console.log(physicalRows)
    //  console.log(source)
    // });
    
    })
    .catch(err => {
      console.log(err);
    })
  }

  /**
   * Get a single Feedback
   * Service: feedbackService (app/components/services/feedback)
   * @param {*} id | id of Feedback 
   */
  getFeedback(id){
    this.feedbackService.getFeedback(id)
    .then(feedback => {
    })
    .catch(err => {
      console.log(err);
    })
  }

    /**
   * Updates a single Feedback
   * Service: feedbackService (app/components/services/feedback)
   * @param {*} id (id of Feedback to be updated)
   */
    editFeedback(row){
       console.log(row);
      }

  /**
   * Updates a single Feedback
   * Service: feedbackService (app/components/services/feedback)
   * @param {*} id (id of Feedback to be updated)
   */
  updateFeedback(id){
    this.feedbackService.updateFeedback(id)
    .then(feedback => {
      console.log(feedback);
    })
    .catch(err => {
      console.log(err);
    })
  }

    /**
   * Delete a single Feedback
   * Service: feedbackService (app/components/services/feedback)
   * @param {*} id (id of Feedback to be updated)
   */
    deleteFeedback(id){
      this.feedbackService.deleteFeedback(id)
      .then(feedback => {
        console.log(feedback);
      })
      .catch(err => {
        console.log(err);
      })
    }
}

export default angular.module('appApp.feedback', [uiRouter])
  .config(routes)
  .component('feedback', {
    template: require('./feedback.html'),
    controller: FeedbackComponent,
    controllerAs: 'feedbackCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/feedback/feedback.component.js